module.exports = __webpack_public_path__ + "static/media/tanque cheio de premios.cdcd23bd.png";